/*# sourceMappingURL=gas-details.component-AQSKXG4S.css.map */
